module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hedo-intro-card1.1.886d35ac.jpg";